import styled from 'styled-components';
import PageTop from '../components/pageTop/PageTop';
import { useEffect, useState } from 'react';
import ScrollToTopButton from '../components/ScrollToTopButton';
import { FilterType, Region } from './FilterData';
import LoanInfoService from '../../service/LoanInfo';
import { isLogin, userGradeType } from '../../utils/auth';
import { SortOption } from '../components/list/data';
import Footer from '../components/footer/Footer';
import List from '../components/list/List';
import AddInterestItemModal from '../components/modal/AddInterestItem';
import SearchTop from './SearchTop';
import mySearchOptionService from '../../service/mySearchOption/mySearchOption';
import { PageContainer } from '../components/common/PageComponent.style';

const Search = () => {
  const [sort, setSort] = useState<SortOption>({
    value: 'DA',
    label: '매각기일 빠른순',
  });
  const [loading, setLoading] = useState(false);
  const [offset, setOffset] = useState<number>(0);
  const [limit, setLimit] = useState<number>(10);
  const [total, setTotal] = useState<number>(0);
  const [data, setData] = useState([]);
  const [showLikeModal, setShowLikeModal] = useState<boolean>(false);
  const [mode, setMode] = useState<string>('add');
  const [selectedIdx, setSelectedIdx] = useState<number>(0);
  const [selectedItem, setSelectedItem] = useState({
    iidx: 0,
    group: '',
    group_idx: 0,
    level: 0,
    memo: '',
  });
  const [activeItem, setActiveItem] = useState<number | null>(null);
  const [filters, setFilters] = useState<FilterType>({
    type: 'a',
    year: '',
    caseNumber: '',
    regionOrCourt: 'r',
    region: [] as Region[],
    address: '',
    court: '',
    itemStatus: [],
    multiItemStatus: [],
    appraisalPrice: { min: '', max: '' },
    minPrice: { min: '', max: '' },
    saleDate: { start: '', end: '' },
    approvalDate: { start: '', end: '' },
    buildingArea: { min: '', max: '' },
    landArea: { min: '', max: '' },
    bidno: '',
    progressStatus: '진행',
    useArea: [],
    multiUseArea: [],
    specialConditionViewOption: 'o',
    specialItemCondition: [],
    multiSpecialItemCondition: [],
    holdingCompany: [],
    multiHoldingCompany: [],
  });

  const saveRecentSearch = async (filters: FilterType) => {
    try {
      const renderCaseNumber = () => {
        if (filters.type === 'a') {
          if (filters.year || filters.caseNumber) {
            return filters.year + '타경' + filters.caseNumber;
          } else {
            return '';
          }
        } else {
          if (filters.caseNumber) return filters.caseNumber;
          return '';
        }
      };
      await mySearchOptionService.save({
        type: filters.type,
        isCourtOrRegion: filters.regionOrCourt,
        court: filters.court,
        region: filters.region
          .map((item) => `${item.sido} ${item.sigungu} ${item.emd}`)
          .join(','),
        search: filters.address,
        search2: renderCaseNumber(),
        search3: '',
        totalCategory: filters.itemStatus.join(','),
        minappraisedValue: Number(filters.appraisalPrice.min),
        maxappraisedValue: Number(filters.appraisalPrice.max),
        minBidPrice: Number(filters.minPrice.min),
        maxBidPrice: Number(filters.minPrice.max),
        minconstructArea: Number(filters.buildingArea.min),
        maxconstructArea: Number(filters.buildingArea.max),
        minlandArea: Number(filters.landArea.min),
        maxlandArea: Number(filters.landArea.max),
        minSaleDate: filters.saleDate.start,
        maxSaleDate: filters.saleDate.end,
        minApprovalDate: filters.approvalDate.start,
        maxApprovalDate: filters.approvalDate.end,
        bidno: filters.bidno,
        bidStatus: filters.progressStatus,
        specialItemCond: filters.specialConditionViewOption,
        specialItem: filters.specialItemCondition.join(','),
        zoning: filters.useArea.join(','),
        sort: '',
        limit: 0,
        offset: 10,
        title: '최근 검색',
        save_type: 'N',
        search_type: filters.type,
      });
    } catch (err) {
      console.log(err);
    }
  };

  const getList = async (
    offset: number,
    sort: {
      value: string;
      label: string;
    },
    filters: FilterType,
  ) => {
    try {
      if (!isLogin()) return;
      const renderCaseNumber = () => {
        if (filters.type === 'a') {
          if (filters.year || filters.caseNumber) {
            return filters.year + '타경' + filters.caseNumber;
          } else {
            return '';
          }
        } else {
          if (filters.caseNumber) return filters.caseNumber;
          return '';
        }
      };

      setLoading(true);
      const res = await LoanInfoService.list(
        filters.type, // 경매  혹은 공매
        filters.regionOrCourt, //  법원 혹은 지역
        filters.court,
        filters.region
          .map((item) => `${item.sido} ${item.sigungu} ${item.emd}`)
          .join(','),
        filters.address || '', // 세부 주소 혹은 건물명
        renderCaseNumber(), // 사건번호
        '', // 키워드
        filters.itemStatus.join(','),
        Number(filters.appraisalPrice.min),
        Number(filters.appraisalPrice.max),
        Number(filters.minPrice.min),
        Number(filters.minPrice.max),
        Number(filters.buildingArea.min),
        Number(filters.buildingArea.max),
        Number(filters.landArea.min),
        Number(filters.landArea.max),
        filters.saleDate.start,
        filters.saleDate.end,
        filters.approvalDate.start,
        filters.approvalDate.end,
        filters.bidno,
        filters.progressStatus,
        filters.specialConditionViewOption,
        filters.specialItemCondition.join(','),
        filters.useArea.join(','),
        '',
        '',
        '',
        sort.value,
        limit,
        offset,
      );
      setData(res.data.list);
      setTotal(res.data.totalNumber);
      saveRecentSearch(filters);
      setLoading(false);
    } catch (error) {
      console.error(error);
    }
  };

  const param = new URLSearchParams(window.location.search);
  const address = param.get('address');
  const options = param.get('options');
  const condition = param.get('specialCondition');

  const parsedFilters = JSON.parse(options?.replace(/'/g, '"') || '{}');

  useEffect(() => {
    if (offset === 0 && data.length === 0) return;
    getList(offset, sort, filters);
  }, [offset]);

  useEffect(() => {
    if (data.length === 0) return;
    setOffset(0);
    getList(0, sort, filters);
  }, [sort]);

  useEffect(() => {
    if (options) {
      setFilters(parsedFilters);
      getList(0, sort, parsedFilters);
    } else if (address) {
      if (address.includes('타경')) {
        const parts = address.split('타경');
        setFilters({
          ...filters,
          year: parts[0],
          caseNumber: parts[1],
          regionOrCourt: 'r',
        });
      } else {
        setFilters({
          ...filters,
          address: address,
          regionOrCourt: 'r',
        });
      }
      const initialFilter = {
        ...filters,
        address: address,
        regionOrCourt: 'r',
      };
      getList(0, sort, initialFilter);
    } else if (condition) {
      setFilters({
        ...filters,
        specialItemCondition: [condition],
        specialConditionViewOption: 'o',
      });
      getList(0, sort, {
        ...filters,
        specialItemCondition: [condition],
        specialConditionViewOption: 'o',
      });
    } else {
      getList(0, sort, filters);
    }
  }, []);

  return (
    <PageContainer>
      <ScrollToTopButton />
      <PageTop text="검색" isMenu={false} />
      <SearchTop
        filters={filters}
        setFilters={setFilters}
        getList={getList}
        sort={sort}
        setOffset={setOffset}
      />
      <List
        data={data}
        totalCount={total}
        sort={sort}
        setSort={setSort}
        offset={offset}
        setOffset={setOffset}
        filters={filters}
        limit={limit}
        loading={loading}
        page="search"
        setSelectedIdx={setSelectedIdx}
        setShowLikeModal={setShowLikeModal}
        setMode={setMode}
        setSelectedItem={setSelectedItem}
        activeItem={activeItem}
        setActiveItem={setActiveItem}
        getList={getList}
      />
      {showLikeModal && (
        <AddInterestItemModal
          setShowLikeModal={setShowLikeModal}
          selectedIdx={selectedIdx}
          mode={mode}
          selectedItem={selectedItem}
          getList={getList}
          offset={offset}
          sort={sort}
          filters={filters}
          setActiveItem={setActiveItem}
        />
      )}
      <Footer type={filters.type} />
    </PageContainer>
  );
};

export default Search;
